import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import { ReactSession } from 'react-client-session';
import { useNavigate } from "react-router-dom";
import { Pagination, Box, PaginationItem } from '@mui/material';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

ReactSession.setStoreType("localStorage");

const Orders = () => {
  const navigate = useNavigate();
  const userId = ReactSession.get("welbeingId");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const limit = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  if (userId <= 0) {
    navigate('/login');
  }

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await fetch(`https://projects.sninfoserv.com/welb-api/admin/order/get-orders/?page=${page}&limit=${limit}&search=${searchQuery}`);
      const result = await response.json();
      console.log(response);
      setOrders(result.data || []);
      setTotalPages(result.pagination.total_pages);
    } catch (error) {
      console.error("Error fetching Orders", error);
    }
    setLoading(false);
  };

 useEffect(() => {
  const delaySearch = setTimeout(() => {
    fetchOrders();
  }, 500); 

  return () => clearTimeout(delaySearch); 
}, [searchQuery, page]);


  const handlePageChange = (event, newPage) => {
    event.preventDefault();
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };



  // Copy
  const handleCopy = () => {
    const text = orders.map(order =>
      `${order.name}\t${order.date}\t${order.order_id}\t${order.count}\t${order.status}\t${order.total}`
    ).join('\n');

    navigator.clipboard.writeText(text)
      .then(() => alert('Copied to clipboard!'))
      .catch(() => alert('Copy failed!'));
  };

  // CSV
  const handleExportCSV = () => {
    const csvRows = [
      ["S.NO", "Customer", "DATE", "Order ID", "ITEMS", "STATUS", "AMOUNT"],
      ...orders.map((order, index) => [index + 1, order.name,
      order.date,
      order.order_id,
      order.count,
      order.status,
      order.total,])
    ];

    const csvContent = csvRows.map(e => e.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Welbeing.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };


  // Pdf
  const handleExportPDF = () => {
    const doc = new jsPDF();
    doc.text("Orders Report", 14, 10);

    const tableColumn = ["S.NO", "Customer", "DATE", "Order ID", "ITEMS", "STATUS", "AMOUNT"];
    const tableRows = orders.map((order, index) => [
      index + 1,
      order.name,
      order.date,
      order.order_id,
      order.count,
      order.status,
      order.total,
    ]);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20,
    });

    doc.save("Welbeing.pdf");
  };

  // Print

  const handlePrint = () => {
  const printContent = document.getElementById("ordersTable").outerHTML;

  const style = `
    <style>
      body {
        margin: 20px;
        font-size: 14px;
      }

      table {
        width: 100%;
        border-collapse: collapse;
      }

      th, td {
        border: 1px solid #ccc;
        padding: 8px 12px;
        text-align: left;
      }

      th {
        background-color: #f0f0f0;
        font-weight: bold;
      }

      tr:nth-child(even) {
        background-color: #f9f9f9;
      }

      caption {
        caption-side: top;
        text-align: center;
        font-size: 18px;
        margin-bottom: 10px;
        font-weight: bold;
      }

      @media print {
        @page {
          margin: 20mm;
        }

        body {
          margin: 0;
        }

        table {
          page-break-after: auto;
        }

        tr {
          page-break-inside: avoid;
          page-break-after: auto;
        }

        td, th {
          page-break-inside: avoid;
          page-break-after: auto;
        }
      }
    </style>
  `;

  const win = window.open('', '', 'height=700,width=900');
  win.document.write('<html><head><title>Print Orders</title>');
  win.document.write(style);
  win.document.write('</head><body>');
  win.document.write(`<table>${printContent}</table>`);
  win.document.write('</body></html>');
  win.document.close();

  setTimeout(() => {
    win.print();
    win.close();
  }, 500);
};


  // Excel
  const handleExportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(orders);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Orders");
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), "Welbeing.xlsx");
  };

  return (
    <>
      <Header />
      <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">
        <div class="body-wrapper">
          <div className="container-fluid">
            <div className="card bg-light-info shadow-none position-relative overflow-hidden" id="card-template">
              <div className="card-body px-4 py-3">
                <div className="row align-items-center">
                  <div className="col-9">
                    <h4 className="fw-semibold mb-8">Today's Orders</h4>
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a className="text-muted" href="dashboard.php">Dashboard</a></li>
                        <li className="breadcrumb-item" aria-current="page">Orders</li>
                      </ol>
                      <br />
                      <a href="" className="btn btn-primary">All Orders</a>
                    </nav>
                  </div>
                  <div className="col-3">
                    <div className="text-center mb-n5">
                      <img src="dist/images/breadcrumb/ChatBc.png" alt="" className="img-fluid mb-n4" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <section>
              <div className="row">
                <div className="col-12">
                  <div className="card" id="card-template">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                        <h5 className="mb-0">File export</h5>
                        <div id="file_export_filter" className="dataTables_filter float-end" style={{ marginLeft: '350px' }}>
                          <label className="d-flex align-items-center gap-2 my-2">Search:<input type="search" className="form-control form-control-sm" placeholder="" value={searchQuery}
                            onChange={(e) => {
                              setSearchQuery(e.target.value);
                             
                            }} /></label>
                        </div>

                      </div>

                      <div className="d-flex flex-wrap gap-2 mb-3 justify-content-start align-items-start">
                        <button className="btn btn-md btn-primary" onClick={handleCopy}>Copy</button>
                        <button className="btn btn-md btn-primary" onClick={handleExportCSV}>CSV</button>
                        <button className="btn btn-md btn-primary" onClick={handleExportExcel}>Excel</button>
                        <button className="btn btn-md btn-primary" onClick={handleExportPDF}>PDF</button>
                        <button className="btn btn-md btn-primary" onClick={handlePrint}>Print</button>
                      </div>



                      <div className="table-responsive" style={{ overflowX: 'auto' }}>
                        <table id="ordersTable" className="table border table-striped table-bordered align-middle">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>Customer</th>
                              <th>Date</th>
                              <th>Order ID</th>
                              <th>Items</th>
                              <th>Status</th>
                              <th>Amount</th>
                              <th>View</th>
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <tr>
                                <td colSpan="8" className="text-center">Loading...</td>
                              </tr>
                            ) : orders.length === 0 ? (
                              <tr>
                                <td colSpan="8" className="text-center fw-bold">
                                  {searchQuery ? "No matching orders found." : "No orders found."}
                                </td>
                              </tr>
                            ) : (
                              orders.map((order, index) => (
                                <tr key={order.id || index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <div
                                        style={{
                                          position: 'relative',
                                          display: 'inline-block',
                                        }}
                                      >
                                        <img src="customer_data/no_image.webp" class="rounded-circle" width="40" height="40" />
                                        {order.orderType === "preOrder" ? (<span
                                          style={{
                                            position: 'absolute',
                                            top: '-20px',
                                            right: "-40px",
                                            borderRadius: '10px',
                                            background: 'yellow',
                                            color: '#333',
                                            padding: '3px 7px',
                                            fontSize: '10px',
                                            fontWeight: 'bold',
                                            zIndex: 10,
                                            boxShadow: '0 0 3px rgba(0, 0, 0, 0.2)',
                                          }}
                                        >
                                          Pre Order
                                        </span>) : (<></>)}
                                      </div>
                                      <div className="ms-3">
                                        <h6 className="mb-0">{order.name}</h6>
                                      </div>
                                    </div>
                                  </td>
                                  <td>{order.order_time}</td>
                                  <td>{order.order_id}</td>
                                  <td>{order.count}</td>
                                  <td>{order.status}</td>
                                  <td className="text-end">{Number(order.grand_total).toFixed(2)}</td>
                                  <td align='right'>
                                    <div className='btn-group'>
                                      <a
                                        type='button'
                                        className='btn btn-success bg-gradient-success'
                                        href={`/orderdetails?id=${order.order_id}`}
                                      >
                                        <i className='ti ti-eye'></i>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>


                        {/* Pagination */}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                          <Pagination
                            count={totalPages}
                            page={page}
                            onChange={handlePageChange}
                            variant="outlined"
                            shape="square"
                            color="primary"
                            sx={{
                              '& .MuiPaginationItem-root': {
                                borderColor: '#5d87ff',
                                color: '#5d87ff',
                                minWidth: '36px',
                                height: '36px',
                                mx: '2px',
                                borderRadius: '4px',
                                fontSize: '14px',
                                '&:hover': {
                                  backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                },
                              },
                              '& .Mui-selected': {
                                backgroundColor: '#5d87ff',
                                color: '#fff',
                                borderColor: '#5d87ff',
                                '&:hover': {
                                  backgroundColor: '#5d87ff',
                                },
                              },
                            }}
                            renderItem={(item) => (
                              <PaginationItem {...item} />
                            )}
                          />
                        </Box>

                      </div>
                    </div>
                  </div>
                </div>
              </div >
            </section >
          </div >
        </div>
      </div>
    </>
  );
};

export default Orders;
